// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.home-heading {
  font-family: "Great Vibes", cursive;
  font-weight: 400;
  line-height: 1.2;
  font-size: clamp(1.8rem, 6vw + 0.2rem, 3rem);
  text-align: center;
}

/* Full width, height auto → keeps aspect ratio and is responsive */
.home-photo {
  width: 100%;
  height: clamp(180px, 35vw, 420px); /* ↓ adjust these to taste */
  object-fit: cover; /* fills width, crops excess height */
  object-position: center; /* focus area (try 'top' / '50% 30%') */
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/HomeComponent/HomeComponent.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,4CAAA;EACA,kBAAA;AAEF;;AACA,mEAAA;AACA;EACE,WAAA;EACA,iCAAA,EAAA,4BAAA;EACA,iBAAA,EAAA,qCAAA;EACA,uBAAA,EAAA,uCAAA;EACA,cAAA;AAEF","sourcesContent":[".home-heading {\r\n  font-family: 'Great Vibes', cursive;\r\n  font-weight: 400;\r\n  line-height: 1.2;\r\n  font-size: clamp(1.8rem, 6vw + 0.2rem, 3rem);\r\n  text-align: center; // optional\r\n}\r\n\r\n/* Full width, height auto → keeps aspect ratio and is responsive */\r\n.home-photo {\r\n  width: 100%;\r\n  height: clamp(180px, 35vw, 420px); /* ↓ adjust these to taste */\r\n  object-fit: cover;                 /* fills width, crops excess height */\r\n  object-position: center;           /* focus area (try 'top' / '50% 30%') */\r\n  display: block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
